<template>
    <div>
      <mentionslegales />
    </div>
  </template>
  
  <script>
  import mentionslegales from '@/components/mentions-legalesComponent.vue';
  
  export default {
    components: {
      mentionslegales
    }
  }
  </script>
  